// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._IlMDgT0AGEq9PDuzDYJ .y7hmYvOvfI067_azAiBi{padding:0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tooltipContainer": `_IlMDgT0AGEq9PDuzDYJ`,
	"linkButton": `y7hmYvOvfI067_azAiBi`
};
export default ___CSS_LOADER_EXPORT___;
